/*
const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};*/

const checkSwatches = () => {
  //console.log('se inicia swatches')
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches label").forEach((input) => {
			input.addEventListener("click", (event) => {
				const color = input.getAttribute('val')
				//console.log('color '+color)
				const product = input.getAttribute('product')
				const secondProduct = input.getAttribute('secondproduct')
				//console.log(input)
				//console.log('.media-'+product+'.second-product-'+secondProduct)
				document.querySelectorAll('.media-' + product).forEach(el => {
                    el.style.objectFit = 'contain';
                    el.style.zIndex = '0';
                });
                document.querySelectorAll('.media-' + product + '.second-product-' + secondProduct).forEach(el => {
                    el.style.display = 'block';
                });
                const firstElement = document.querySelector('.media-' + product + '.second-product-' + secondProduct);
                if (firstElement) {
                    firstElement.style.opacity = '1';
                }
                document.querySelectorAll('.media-' + product).forEach(el => {
                    if (!el.classList.contains('second-product-' + secondProduct)) {
                        el.style.display = 'none';
                    }
                });
                let url = input.getAttribute('url');
                var productCard = input.closest('.collection-product-card');
                productCard.querySelectorAll('label').forEach(label => {
                    label.classList.remove('round-border');
                });
                input.classList.add('round-border');
                //console.log(url);
                productCard.querySelectorAll('a').forEach(a => {
                    a.setAttribute('href', url);
                });
				var variantsInfo = JSON.parse(document.getElementById('variants_data_'+product).textContent);
				let sizes = []
				let productPrice
				let productCompare
				let mainProduct
				for(const variant of variantsInfo){
					if(variant.product == secondProduct){
						if(variant.available){
							sizes.push(variant.title)
							productPrice = variant.product_price
							productCompare = variant.product_compare_at_price
							mainProduct = variant.main
						}
					}
				}
				//console.log(sizes)
                  //console.log('id '+mainProduct)
				let sizeModal = input.closest('.collection-product-card').querySelector('.size__modal');
                sizeModal.innerHTML = '';
                for (const size of sizes) {
                    sizeModal.innerHTML += `<div class="size__btn" data-variantcolor="${color}" data-product="${product}" data-secondproduct="${secondProduct}" data-variantsize="${size}">${size}</div>`;
                }
                //console.log(document.querySelector('.product-card-' + mainProduct + ' .price'));
              //console.log('.product-card-' + mainProduct + ' .price-item.price-item--regular')
                if (productCompare) {
                    //console.log('Hay compare');
                    document.querySelector('.product-card-' + mainProduct + ' .price-item.price-item--regular').textContent = productCompare;
                    document.querySelector('.product-card-' + mainProduct + ' .price-item.price-item--sale').textContent = productPrice;
                    document.querySelector('.product-card-' + mainProduct + ' .price__sale').style.display = 'flex';
                    document.querySelector('.product-card-' + mainProduct + ' .price__regular').style.display = 'none';
                    document.querySelector('.product-card-' + mainProduct + ' .price').classList.add('price--on-sale');
                    const salePercentage = (100 - (parseFloat(productPrice.replace('$ ', '').replace(',', '')) * 100 / parseFloat(productCompare.replace('$ ', '').replace(',', '')))).toFixed(2);
                    document.querySelector('.product-card-' + mainProduct + ' .badge--bottom-left').textContent = `Sale -${salePercentage} %`;
                } else {
                    document.querySelector('.product-card-' + mainProduct + ' .price-item.price-item--regular').textContent = productPrice;
                    document.querySelector('.product-card-' + mainProduct + ' .price').classList.remove('price--on-sale');
                    document.querySelector('.product-card-' + mainProduct + ' .price__sale').style.display = 'none';
                    document.querySelector('.product-card-' + mainProduct + ' .price__regular').style.display = 'flex';
                }
				quickPurchase()
			});
		});
	});
	hideColorOptions()
};

function handleQuickAddClick(event) {
    const button = event.currentTarget;
    const sizeModal = button.closest('.collection-product-card').querySelector('.size__modal');
    if (sizeModal) {
        sizeModal.classList.toggle('op-1');
    }
}

const quickPurchase = () => {
	const quickAddButtons = document.querySelectorAll('.quick_add_btn');
    quickAddButtons.forEach(button => {
        button.removeEventListener('click', handleQuickAddClick);
        button.addEventListener('click', handleQuickAddClick); 
    });
  
    const sizeButtons = document.querySelectorAll('.size__btn');

    // Iterate over each button to attach event listeners
    sizeButtons.forEach(button => {
        // Remove any existing click event listeners to prevent duplicates
        button.removeEventListener('click', handleSizeButtonClick);
    
        // Define the event handler function
        function handleSizeButtonClick() {
            //console.log('entra a comprar');
            // Retrieve data attributes from the clicked button
            const color = button.getAttribute('data-variantcolor');
            const size = button.getAttribute('data-variantsize');
            //console.log(color + ' / ' + size);
            const product = button.getAttribute('data-product');
            const secondProduct = button.getAttribute('data-secondproduct');
	  var variantsInfo = JSON.parse(document.getElementById('variants_data_' + product).textContent);
		//console.log('Entra al quick')
	  for (const variant of variantsInfo) {
		if(variant.product == secondProduct){
			//console.log(variant)
			if (variant.title == size) {
				//console.log(variant.id);

				let config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];
				const cart = document.querySelector("cart-drawer")
				const formData = new FormData();
				formData.append('Talla', size);
				formData.append('form_type', 'product'); 
				formData.append('id', variant.id);
				formData.append('quantity', '1');
				formData.append('properties[color]', color);
				formData.append('product-id', product);
				if (cart) {
					formData.append(
						"sections",
						cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					cart.setActiveElement(document.activeElement);
				}
				config.body = formData;
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
                      setTimeout(() => {
                        executeInCartUpdate()
                      }, 500);

						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							cart.renderContents(response);
						}
                      loadDrawerRecomendations()
					})
					.catch((e) => {
						console.error(e);
					})
			}
		}
	  }
        }
    
        // Attach the click event listener
        button.addEventListener('click', handleSizeButtonClick);



      
	});
  };

$(document).ready(function(){
	colorSwatches();
	hideColorOptions()
	//quickPurchase();
})

function hideColorOptions() {
    // Select all elements with the class '.product-form__controls'
    const controls = document.querySelectorAll('.product-form__controls');

    // Add mouseover event listener to each control
    controls.forEach(control => {
        control.addEventListener('mouseover', function() {
            const moreElements = control.querySelector('.more-elements');
            if (moreElements) {
                control.querySelectorAll('.extra-element').forEach(element => {
                    element.style.display = 'block'; // Show all extra elements
                });
                moreElements.style.display = 'none'; // Hide 'more-elements'
            }
        });

        // Add mouseout event listener to each control
        control.addEventListener('mouseout', function() {
            const moreElements = control.querySelector('.more-elements');
            if (moreElements) {
                control.querySelectorAll('.extra-element').forEach(element => {
                    element.style.display = 'none'; // Hide all extra elements
                });
                moreElements.style.display = 'block'; // Show 'more-elements'
            }
        });
    });
}

function toggleCheck(id){
	const element = document.getElementById(id);
	element.checked = !element.checked;
}

function colorSwatches() {
	checkSwatches();
	quickPurchase();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		quickPurchase();
	});
}

